import { RequestStatus } from '../enums/status.enum';

export const statusStylesWithColor: Record<RequestStatus, string> = {
  [RequestStatus.Pending]: '#7F7F7F',
  [RequestStatus.Approved]: '#2EB275',
  [RequestStatus.Rejected]: '#FF6347',
};
